import { render, staticRenderFns } from "./OrmBatchingQuotes.vue?vue&type=template&id=9ac14d4c"
import script from "./OrmBatchingQuotes.vue?vue&type=script&lang=js"
export * from "./OrmBatchingQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports